export default {
  // 发送api请求的域名(必须是域名)
  host: process.env.VUE_APP_HOST,
  // api的路径
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // 需要放置在服务器的静态资源地址
  sourceURL: process.env.VUE_APP_SOURCE_URL,
  title: process.env.VUE_APP_TITLE,
  // 以下为可覆盖config文件内容,如果定义,在config中的相关设置会被覆盖
  appID: process.env.VUE_APP_ID,
  actID: process.env.VUE_APP_ACTID,
  wxJSSDKConfig: process.env.VUE_APP_WEIXIN_JSSDK_CONIFG_URL,
  authUrl: process.env.VUE_APP_AUTH_URL,
  authScope: process.env.VUE_APP_AUTH_SCOPE || 'snsapi_userinfo',
  // MTA 配置
  MTAConfig: {
    open: process.env.VUE_APP_MTA === 'on',
    config: {
      sid: process.env.VUE_APP_MTA_SID, // 必填，统计用的appID
      cid: process.env.VUE_APP_MTA_CID, // 如果开启自定义事件，此项目为必填，否则不填
      autoReport: process.env.VUE_APP_MTA_AUTOREPORT, // 是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
      senseHash: process.env.VUE_APP_MTA_SENSE_HASH, // hash锚点是否进入url统计
      senseQuery: process.env.VUE_APP_MTA_SENSE_QUERY, // url参数是否进入url统计
      performanceMonitor: process.env.VUE_APP_MTA_PERFORMANCE_MONITOR // 是否开启性能监控
    }
  }
}
